import LabelField from '@app/components/atoms/LabelField/LabelField'
import { LOCALISE } from '@app/constant/DateTimeConstant'
import { toOptionValues } from '@app/libs/cast'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import Autocomplete from '@mui/material/Autocomplete'
import Checkbox from '@mui/material/Checkbox'
import FormHelperText from '@mui/material/FormHelperText'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const BasicInformationSection = ({ register, errors, control, setValue, getValues, categories, data }) => {
  const { t } = useTranslation()
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
  const checkedIcon = <CheckBoxIcon fontSize="small" />

  const handleChange = (e, value) => {
    const set =
      value &&
      value.reduce((results, current) => {
        if (!results.some((result) => result.name === current.name)) results.push(current)
        return results
      }, [])
    setValue('tags', set)
  }

  const handleKeyDown = (e) => {
    if ('Shift' === e.key && e.target.value && !getValues('tags').some((tag) => tag.name === e.target.value)) {
      setValue('tags', [
        ...getValues('tags'),
        {
          name: e.target.value,
          value: '',
        },
      ])
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <LabelField required title={t('VOUCHER.NAME')}>
          <TextField
            fullWidth
            id="name"
            name="name"
            size="small"
            variant="outlined"
            {...register('name')}
            error={!!errors.name}
            helperText={errors.name?.message}
          />
        </LabelField>
      </Grid>

      <Grid item xs={12}>
        <LabelField title={t('VOUCHER.CHOOSE_MERCHANT')}>
          <TextField
            disabled
            fullWidth
            id="merchant"
            name="merchant"
            size="small"
            value={getValues('merchant')}
            variant="outlined"
            {...register('merchant')}
            error={!!errors.name}
            helperText={errors.merchant?.message}
          />
        </LabelField>
      </Grid>

      <Grid item xs={12}>
        <LabelField title={t('VOUCHER.CHOOSE_CATEGORY')}>
          <Controller
            control={control}
            name="categories"
            render={({ field }) => (
              <Autocomplete
                disableCloseOnSelect
                {...field}
                multiple
                getOptionLabel={(option) => option.name}
                id="checkboxes-tags-demo"
                isOptionEqualToValue={(option, value) => option.id === value.id}
                options={categories}
                renderInput={(params) => (
                  <TextField
                    variant="outlined"
                    {...params}
                    error={!!errors.categories}
                    helperText={errors.categories?.message}
                  />
                )}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox checked={selected} checkedIcon={checkedIcon} icon={icon} sx={{ marginRight: 8 }} />
                    {option.name}
                  </li>
                )}
                size="small"
                onChange={(e, value) => {
                  setValue('categories', value)
                }}
              />
            )}
          />
        </LabelField>
      </Grid>

      <Grid item xs={12}>
        <LabelField required={true} title={t('VOUCHER.PRICE')}>
          <TextField
            fullWidth
            name="price"
            size="small"
            type="number"
            variant="outlined"
            {...register('price')}
            error={!!errors.price}
            helperText={errors.price?.message}
          />
        </LabelField>
      </Grid>

      <Grid item xs={12}>
        <LabelField required={true} title={t('VOUCHER.QUANTITY')}>
          <TextField
            fullWidth
            name="quantity"
            size="small"
            type="number"
            variant="outlined"
            {...register('quantity')}
            error={!!errors.quantity}
            helperText={errors.quantity?.message}
          />
        </LabelField>
      </Grid>
      <Grid item xs={12}>
        <LabelField title={t('VOUCHER.DETAIL_LINK')}>
          <TextField
            fullWidth
            name="info_link"
            size="small"
            variant="outlined"
            {...register('info_link')}
            error={!!errors.info_link}
            helperText={errors.info_link?.message}
          />
        </LabelField>
      </Grid>

      <Grid item xs={12}>
        <LabelField title={t('VOUCHER.HASHTAGS')}>
          <Controller
            control={control}
            name="tags"
            render={({ field }) => (
              <Autocomplete
                {...field}
                multiple
                getOptionLabel={(option) => option.name}
                id="tags-outlined"
                isOptionEqualToValue={(option, value) => option.value === value.value}
                name="tags"
                options={toOptionValues(data.tags)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={t('VOUCHER.HASHTAGS_PLACE_HOLDER')}
                    variant="outlined"
                    onKeyDown={(e) => handleKeyDown(e)}
                  />
                )}
                size="small"
                onChange={(e, value) => handleChange(e, value)}
              />
            )}
          />
        </LabelField>
      </Grid>

      <Grid item xs={12}>
        <LabelField required={true} title={t('VOUCHER.EXPIRED_AT')}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              inputFormat={LOCALISE.DATE_TIME_FORMAT}
              minDateTime={new Date()}
              name="expired_date"
              renderInput={(params) => <TextField fullWidth variant="outlined" {...params} />}
              {...register('expired_date')}
              value={getValues('expired_date')}
              onChange={(value) => {
                setValue('expired_date', value, { shouldValidate: true, shouldDirty: true })
              }}
            />
            <FormHelperText error={!!errors.expired_date} sx={{ pl: 2 }}>
              {errors.expired_date?.message}
            </FormHelperText>
          </LocalizationProvider>
        </LabelField>
      </Grid>
    </Grid>
  )
}
export default BasicInformationSection
